// import Sass
import './style.scss';

// Video Player
document.addEventListener('DOMContentLoaded', () => {
    const allVideoPlayer = document.querySelectorAll('.wp-block-vpb-video');
    Object.values(allVideoPlayer).map(videoPlayer => {
        const { controls, repeat, muted, autoplay, resetOnEnd, autoHideControl } = JSON.parse(videoPlayer.dataset.video);

        const videoEl = document.querySelector(`#${videoPlayer.id} .vpbVideoPlayer video`);

        // Controls handler
        const controlsHandler = controls => {
            const newControls = [];
            Object.keys(controls).map(item => {
                if (controls[item]) {
                    newControls.push(item);
                }
            });
            return newControls;
        };

        new Plyr(videoEl, {
            controls: controlsHandler(controls),
            clickToPlay: false,
            loop: { active: repeat },
            muted,
            autoplay,
            resetOnEnd,
            hideControls: autoHideControl,
        });
    });
});